import { ScrollText } from 'lucide-react'
import { useTutorial } from '../../contexts/TutorialContext'
import { useCurrentAction } from '../../hooks/useCurrentAction'
import { TUTORIAL_COPY } from '../../constants/tutorialContent'

/**
 * TutorialResumePill — floating re-open valve (collapsed/waiting state).
 * z-fixed (below the overlay), full game access, one click resumes. Waiting
 * copy mirrors the live action type (run/gathering/job) so the pause stays
 * legible (PRD risk note); ActionHUD owns the timer (FR-8).
 */
export default function TutorialResumePill() {
    const { resume, currentStep, uiMode } = useTutorial()
    const { currentAction } = useCurrentAction()
    const chip = currentStep ? TUTORIAL_COPY.logChip(currentStep.id) : TUTORIAL_COPY.logChip(1)
    const waiting = uiMode === 'waiting'
    const actionLive = currentAction && !currentAction.completed
    const waitingText = (actionLive && TUTORIAL_COPY.pillWaitingByAction[currentAction.type]) || TUTORIAL_COPY.pillWaiting

    return (
        <button
            type="button"
            className="tcd-pill"
            onClick={resume}
            aria-label={TUTORIAL_COPY.resumeAria}
            data-testid="tutorial-pill"
        >
            <ScrollText size={16} aria-hidden="true" />
            <span className="tcd-pill__chip">{chip}</span>
            <span>{waiting && actionLive ? waitingText : TUTORIAL_COPY.pillCollapsed}</span>
            {waiting && actionLive && <span className="tcd-pill__dot" aria-hidden="true" />}
        </button>
    )
}
